import BaseCtrl from 'edge/platform/base/BaseCtrl';
import DocumentUtil from 'edge/gateway/util/DocumentUtil';

var fn = function fn(ModalService, $window, $scope, PolicyService, CancellationService, $q, $stateParams) {

    $scope.docList = ['New Submission Application', 'Agent Quote Worksheet', 'Emod Worksheet', 'Group Election Form', 'Loss Runs', 'NCCI Release Form', 'Out of State Coverage Application', 'Payment Receipt', 'Prior Carrier Information/Loss History', 'Producer of Record Change', 'Other'];

    $scope.docType = "none";
    $scope.descRequired = false;
    $scope.docUploaded = false;
    $scope.toggleUpload = function () {
        $scope.docUploaded = false;
        $scope.docType = "none";
        $scope.description = "";
    };
    $scope.checkDescRequired = function () {
        var doc = angular.element(document.querySelector('#docType')).val();
        if (doc == "Other") {
            $scope.descRequired = true;
        } else {
            $scope.descRequired = false;
        }
    };

    $scope.clickUpload = function () {
        angular.element('input[type=file]').trigger('click');
    };

    function _getFileExtension(name) {
        var extension = name.split('.').pop();
        return extension || '';
    }
    // New Functionality to upload file to the Server
    $scope.uploadFile = function (files) {
        for (var i = 0; i < files.length; i++) {

            var desc = angular.element(document.querySelector('#description')).val();
            var doc = angular.element(document.querySelector('#docType')).val();
            var user = angular.element(document.querySelector('#userName')).val();
            //var count=angular.element(document.querySelector( '#pageCount' )).val();
            if (doc == "Other") {
                if (desc == undefined || desc == "" || desc.trim() == '') {
                    ModalService.showError('platform.documentupload.DocumentUploadDirective.Description Required', 'platform.widgets.fileupload.templates.Please enter Description.');
                    return;
                } else {
                    $scope.descEntered = true;
                }
            }
            if (doc == "none") {
                ModalService.showError('platform.documentupload.DocumentUploadDirective.Error', 'platform.widgets.fileupload.templates.Please select the Document Type.');
                return;
            }
            var fileData = { policyNumber: $stateParams.policyNumber, encodedFile: '', contentType: '', fileName: '', description: desc, docType: doc, userName: user };
            var file = files[i];
            _uploadFileToServer(file, fileData);
        }
    };

    function _uploadFileToServer(file, fileData) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {

            var encodedFileBase64 = reader.result.substring(reader.result.indexOf(",") + 1);;
            fileData.encodedFile = encodedFileBase64;
            fileData.fileName = file.name;
            fileData.contentType = file.type;
            //console.log("-->"+file.type+"-->"+file.size);

            var fileName = file.name;
            var extension = fileName.substring(fileName.lastIndexOf('.'));
            var extValid = [".pdf"]; //valid file typed accepting only pdf for now 
            if (!extValid.includes(extension.toLowerCase())) {
                ModalService.showError(fileName + ' is not a valid file type.', 'platform.widgets.fileupload.templates.Only Pdf file type is allowed (size < 5 MB).');
                return;
            }

            if (file.size > 5242880) {
                ModalService.showError('platform.widgets.fileupload.templates.size exceeds 5MB', 'platform.widgets.fileupload.templates.Please reduce the size or split the document into seperate files and upload.');
                return;
            }

            //return
            PolicyService.uploadForNewSubmission(fileData).then(function (res) {
                $scope.docUploaded = true;
                /*ModalService.showInfo('Upload Successful',
                              fileName+' sent to Montana State Fund.'
                          );*/
            }, function () {
                ModalService.showError('platform.documentupload.DocumentUploadDirective.Error', 'platform.widgets.fileupload.templates.An exception occurred. Please try again later, if the problem persists please contact Montana State Fund at 406-495-5000.');
            });
        };
        reader.onerror = function (error) {
            ModalService.showError('platform.documentupload.DocumentUploadDirective.Error', 'platform.widgets.fileupload.templates.An exception occurred. Please try again later, if the problem persists please contact Montana State Fund at 406-495-5000.');
        };
    }

    /***
     * 
     * 
     * Policy Documents Download Section
     * 
     */

    function covertBlobToURL(blobData) {
        var binary = DocumentUtil.decode(blobData);
        var len = binary.length;
        //var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        // Create Base64 Object
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
            // do nothing because fileUrl generation is not supported in IE
        } else {
            // for Chrome Firefox etc
            var file = new Blob([view], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            //$window.open(fileURL);
            return fileURL;
        }
    }

    /* 
     $scope.openURL =(url)=>{
       	// Create Base64 Object
     	if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
     	    var binary = base64.decode(url.documentBlob);
          var len = url.documentBlob.length;
             //var buffer = new ArrayBuffer(len);
             var view = new Uint8Array(len);
             for (var i = 0; i < len; i++) {
                 view[i] = binary.charCodeAt(i);
             }
             if (url.fileName==undefined) { // for IE
             	url.fileName='Document'; 
             }
     		window.navigator.msSaveOrOpenBlob(new Blob([view],{ type: 'application/pdf' }), url.fileName);
         }else{ // for Chrome Firefox etc
         	$window.open(url.documentURL);
         }
     	
     }*/

    //function to get document blob and open in frontend for individual data
    $scope.openURL = function (url) {

        PolicyService.getDocumentsByFileId($stateParams.policyNumber, $rootScope.$root.authData.userData.email, url.documentBlob).then(function (data) {
            angular.forEach(data, function (fileData) {
                // Create Base64 Object
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // for IE
                    var binary = DocumentUtil.decode(fileData.documentBlob);
                    var len = binary.length;
                    //var buffer = new ArrayBuffer(len);
                    var view = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        view[i] = binary.charCodeAt(i);
                    }
                    if (url.fileName == undefined) {
                        // for IE
                        url.fileName = 'Document';
                    }
                    window.navigator.msSaveOrOpenBlob(new Blob([view], { type: 'application/pdf' }), url.fileName);
                } else {
                    // for Chrome Firefox etc
                    if (fileData.documentBlob != null && fileData.documentBlob != undefined) {
                        var _url = covertBlobToURL(fileData.documentBlob);
                        //res.documentURL = _url.replace("unsafe:","");
                        $window.open(_url);
                    }
                }
            });
        }, function () {
            //$scope.CCAllowed=false; 
        });
    };

    $scope.filteredDocuments = $scope.documents;

    $scope.$watchCollection('documents', function (newValue, oldValue) {

        if (newValue && newValue !== oldValue) {
            $scope.filteredDocuments = $scope.documents;
            $scope.$emit('documentsUpdated', $scope.documents);
        }
    });

    $scope.$watch('dataTemplate', function () {
        $scope.metadataTemplate = $scope.documentMetadataTemplate;
    });
    $scope.$watch('documentQuery', function () {
        $scope.applyFilter();
    });

    $scope.isRecentlyAdded = function (id) {
        return _.contains($scope.recentlyAddedIDs, id);
    };

    $scope.$on('fileuploaddone', function (e, data) {
        $scope.recentlyAddedIDs.push(data.result.result.publicID);
    });

    $scope.$on('fileuploadstart', function () {
        $scope.recentlyAddedIDs = [];
    });

    $scope.applyFilter = function () {
        if ($scope.documentQuery != undefined && $scope.documentQuery != "") {
            $scope.filteredDocuments = $filter('filter')($scope.documents, {
                fileName: $scope.documentQuery
            });
        } else {
            $scope.filteredDocuments = $scope.fullDocumentsData;
        }
    };

    $scope.closeAlert = function (index) {
        $scope.alerts.splice(index, 1);
    };

    $scope.allDocs = 0;
    $scope.pageSize = 20;
    $scope.queryOptions = {
        offsetStart: 0,
        offsetEnd: $scope.pageSize - 1
    };

    function getDocsCurrentUser() {
        if ($scope.allDocs == 0) {
            $scope.allDocs = PolicyService.getDocumentsForPolicy($stateParams.policyNumber, $rootScope.$root.authData.userData.email);
        }
        return $scope.allDocs;
    }

    function updateDocumentData() {
        console.log("innn---->");

        return getDocsCurrentUser().then(function (data) {

            var finalData = [];
            angular.forEach(data, function (res) {
                if (res.documentBlob != null || res.documentBlob != undefined) {
                    var _url = covertBlobToURL(res.documentBlob);
                    res.documentURL = _url;
                }
                finalData.push(res);
            });

            $scope.filteredJobs = $filter('orderBy')(finalData, 'deliveryDate').reverse();

            $scope.allJobData = $scope.filteredJobs.slice($scope.queryOptions.offsetStart, $scope.queryOptions.offsetEnd + 1);

            return {
                'items': $scope.allJobData,
                'maxNumberOfResults': finalData.length
            };
        }, function () {
            $scope.jobsLoading = false;
        });
    }

    $scope.tableTitle = " "; //Empty title since title is already available
    $scope.loadingComplete = true;
    var _getLoadByOffset = _.memoize(function () {
        return function (offsetStart, offsetEnd) {
            $scope.queryOptions.offsetStart = offsetStart;
            $scope.queryOptions.offsetEnd = offsetEnd;
            return updateDocumentData();
        };
    });

    $scope.getLoadByOffset = function () {

        return _getLoadByOffset();
    };
};

fn.$inject = ['ModalService', '$window', '$scope', 'PolicyService', 'CancellationService', '$q', '$stateParams'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/UploadApplicationCtrl.js
// module id = 1688
// module chunks = 0